"use client";
import { useCheckboxCheck } from "../checkbox/checkbox-check.js";
import { MenuItemCheckedContext } from "./menu-context.js";
import { createElement, createHook, forwardRef } from "@ariakit/react-utils";
import { useContext } from "react";
//#region src/menu/menu-item-check.tsx
const TagName = "span";
/**
* Returns props to create a `MenuItemCheck` component.
* @see https://ariakit.com/components/menu
* @example
* ```jsx
* const props = useMenuItemCheck({ checked: true });
* <Role {...props} />
* ```
*/
const useMenuItemCheck = createHook(function useMenuItemCheck({ store, checked, ...props }) {
	const context = useContext(MenuItemCheckedContext);
	checked = checked ?? context;
	props = useCheckboxCheck({
		...props,
		checked
	});
	return props;
});
/**
* Renders a checkmark icon when the
* [`checked`](https://ariakit.com/reference/menu-item-check#checked) prop is
* `true`. The icon can be overridden by providing a different one as children.
*
* When rendered inside
* [`MenuItemCheckbox`](https://ariakit.com/reference/menu-item-checkbox) or
* [`MenuItemRadio`](https://ariakit.com/reference/menu-item-radio) components,
* the [`checked`](https://ariakit.com/reference/menu-item-check#checked) prop
* is automatically derived from the context.
* @see https://ariakit.com/components/menu
* @example
* ```jsx {5,9}
* <MenuProvider defaultValues={{ apple: true, orange: false }}>
*   <MenuButton>Fruits</MenuButton>
*   <Menu>
*     <MenuItemCheckbox name="apple">
*       <MenuItemCheck />
*       Apple
*     </MenuItemCheckbox>
*     <MenuItemCheckbox name="orange">
*       <MenuItemCheck />
*       Orange
*     </MenuItemCheckbox>
*   </Menu>
* </MenuProvider>
* ```
*/
const MenuItemCheck = forwardRef(function MenuItemCheck(props) {
	return createElement(TagName, useMenuItemCheck(props));
});
//#endregion
export { MenuItemCheck, useMenuItemCheck };

//# sourceMappingURL=menu-item-check.js.map